import api from 'api';
import { useEffect, useState } from 'react';
import Moment from 'react-moment';
import { Link, useParams, useHistory } from 'react-router-dom';
import './list.scss';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';
import { arrayMove } from '@dnd-kit/sortable';

function List() {
    const [board, setBoard] = useState<any>(null);
    const [boardName, setBoardName] = useState('');
    const [boardMenuOpen, setBoardMenuOpen] = useState(false);
    const params: any = useParams();
    const history = useHistory();
    const [activeSection, setActiveSection] = useState<any>([]);
    const toggleSection = (id: number) => {
        var hasId = activeSection.includes(id);
        if (hasId) {
            setActiveSection([...activeSection.filter((x: any) => x !== id)]);
        } else {
            setActiveSection([...activeSection, id]);
        }
    };

    const updateBoard = () => {
        api.board.update(params.boardId, boardName, board.Background);
    }

    const deleteBoard = () => {
        let deleteBoard = window.confirm(`Are you sure you want to delete this board?`);

        if (deleteBoard) {
            api.board.delete(params.boardId).then(() => {
                history.replace(`/client/${params.clientId}/dashboard`);
            })
        }
    }

    const handleDragEnd = (e: any) => {
        const { source, destination } = e;

        if (!destination) return;
        if (source.droppableId === destination.droppableId && source.index === destination.index) return;

        if (e.type === "column") {
            updateColumnPosition(source.index, destination.index);
        } else {
            updateTicketPosition(e);
        }
    }

    const updateColumnPosition = (oldIndex: number, newIndex: number) => {
        const column: any = board.Columns![oldIndex];
        setBoard({
            ...board,
            Columns: arrayMove(board.Columns!, oldIndex, newIndex)
        })
        api.column.update(params.clientId, params.boardId, column.Id, column.Description, newIndex + 1);
    }

    const updateTicketPosition = (e: DropResult) => {
        const { source, destination, draggableId } = e;
        var copiedColumns = [...board.Columns!];
        api.ticket.updatePosition(parseInt(draggableId), params.clientId, copiedColumns[parseInt(destination!.droppableId)].Id, destination!.index);
        const [removed] = copiedColumns[parseInt(source.droppableId)].Tickets.splice(source.index, 1);

        if (source.droppableId === destination?.droppableId) {
            copiedColumns[parseInt(destination!.droppableId)].Tickets.splice(destination.index, 0, removed);
            setBoard({
                ...board,
                Columns: copiedColumns
            })
        } else {
            copiedColumns[parseInt(destination!.droppableId)].Tickets.splice(destination!.index, 0, removed);
            setBoard({
                ...board,
                Columns: copiedColumns
            })
        }
    }

    useEffect(() => {
        api.board.get(params.boardId).then(board => {
            setBoard(board);
            // api.column.getAll(params.clientId, params.boardId).then(columns => {
            //   setBoard({
            //     ...board,
            //     Columns: columns
            //   })
            // })
            setBoardName(board.Description);
        })
    }, [params.clientId, params.boardId])

    return (
        <div id="list">
            <div id="list-header">
                <Link to="../dashboard">
                    <i className="fa fa-home"></i>
                </Link>
                <input type="text" value={boardName} onChange={(e) => setBoardName(e.currentTarget.value)} onBlur={updateBoard} />
                <i className="fal fa-list"></i>
                <Link to={`/client/${params.clientId}/board/${params.boardId}`}>
                    <i className="fal fa-border-all"></i>
                </Link>
                <i className="far fa-ellipsis-h" onClick={() => setBoardMenuOpen(!boardMenuOpen)}></i>
                <ul id="board-menu" className={boardMenuOpen ? "open" : ""}>
                    <li>Members</li>
                    <li onClick={deleteBoard}>Delete Board</li>
                </ul>
            </div>
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="columns" type="column">
                    {(provided) => {
                        return (
                            <div id="list-container" ref={provided.innerRef} {...provided.droppableProps}>
                                {board?.Columns?.map((el: any, i: number) => {
                                    return (
                                        <Draggable draggableId={el.Id.toString()} index={el.Id} key={el.Id}>
                                            {(provided) => {
                                                return (
                                                    <table className="list-section" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                        <thead>
                                                            <tr>
                                                                <th className="toggle" onClick={() => toggleSection(el.Id)}>
                                                                    <i className={`far ${activeSection.includes(el.Id) ? "fa-angle-right" : "fa-angle-down"}`}></i>
                                                                </th>
                                                                <th className="title">{el.Description}</th>
                                                                <th className="created">Created</th>
                                                                <th className="due">Due</th>
                                                            </tr>
                                                        </thead>
                                                        <Droppable droppableId={i.toString()} type="ticket">
                                                            {(provided) => {
                                                                return (
                                                                    <tbody className={activeSection.includes(el.Id) ? "" : "open"} ref={provided.innerRef} {...provided.droppableProps}>
                                                                        {!el.Tickets.length ? (
                                                                            <tr className="list-section-ticket">
                                                                                <td></td>
                                                                                <td></td>
                                                                                <td></td>
                                                                                <td></td>
                                                                            </tr>
                                                                        ) : (
                                                                            el.Tickets.map((e: any, i: number) => {
                                                                                return (
                                                                                    <Draggable draggableId={e.Id.toString()} index={e.Id} key={e.Id.toString()}>
                                                                                        {(provided) => {
                                                                                            return (
                                                                                                <tr className="list-section-ticket" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                                                    <td className="toggle"></td>
                                                                                                    <td className="title">{e.Heading}</td>
                                                                                                    <td className="created"><Moment fromNow>{e.DateCreated}</Moment></td>
                                                                                                    <td className="due">{e.DueDate ? (<Moment format="d MMM yyyy">{e.DueDate}</Moment>) : ("-")}</td>
                                                                                                </tr>
                                                                                            )
                                                                                        }}
                                                                                    </Draggable>

                                                                                );
                                                                            })
                                                                        )}

                                                                        {provided.placeholder}
                                                                    </tbody>
                                                                )
                                                            }}
                                                        </Droppable>
                                                    </table>
                                                )
                                            }}
                                        </Draggable>
                                    )
                                })}
                                {provided.placeholder}
                            </div>
                        )

                    }}
                </Droppable>
            </DragDropContext>
        </div>
    )
}

export default List;